import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        

        <section className="about-section">
          <p>
            Atatürk Kültür Merkezi Başkanlığının Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak ve bu alandaki kişi ve kuruluşları destekleyip onlarla iş birliği yapmak misyonu ve Türk kültürü araştırmalarında ulusal ve uluslararası düzeyde en yetkin Kurumlardan biri olmak; kültürümüzün temel değerlerini yaşatarak milli kültürü çağdaş medeniyetler seviyesi üzerine çıkarmak vizyonunu göz önüne alarak; Cumhuriyet Dönemi Türk Sanatı Ansiklopedisi (CTS) kapsamında Türkiye Cumhuriyeti dönemindeki sanatı araştırmak, belgelemek, anlamak, yaymak suretiyle sanat tarihine ve kültürel mirasa katkıda bulunmak ve bu alanda çalışan öncelikli olarak öğrencilere, bu alanda çalışan akademisyenlere, öğretmenlere ve sanata ilgi duyan herkese güvenilir, kolay ulaşılabilir bir açık kaynak sağlamak şiarıyla yola çıkılmıştır. Cumhuriyet Dönemi Türk Sanatı Ansiklopedisi (CTS) Kurum faaliyetleri ile etkileşimde bulunduğumuz kitlenin geribildirimleri ve Kurumumuzun faaliyet alanları ile ilgili Cumhuriyetimizin 100. yılı projeksiyonu sonucu oluşturulan ihtiyaç analizi çerçevesinde şekillendirilmiştir.
          </p>
          <p>
            Günümüzün iletişim dünyasındaki bilgi akışı hem sevindirici hem de bilgi kirliliği açısından endişe vericidir. İletişim olanaklarının artışının beraberinde getirdiği bilgi kirliliği ancak Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak üzerine çalışan ulusal ve uluslararası düzeyde doğru temsil kabiliyetine sahip kurumlar aracılığı ile gerçekleştirilebileceği kanaatindeyiz. Bu noktadan hareketle çağın gerekliliklerini de göz önüne alarak Kurumumuz kültür alanında güvenilir bir kaynak sağlayıcısı olma hedefiyle, çalışma alanımızdaki farklı alanlarda dijital kaynaklar oluşturarak ilgililerine ulaştırma çalışmalarını sürdürmektedir.
          </p>
          <p>
            Kurumumuzun önemli açık kaynak projelerinden biri olan Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi (CTS), alanında toplu bilgi ve açık kaynak erişimi ile Türkiye&apos;de ilk olma özelliği taşımaktadır. Türk sanatı tarihi ve kültürel mirasımıza katkıda bulunulması ve elde edilecek bilgilerin toplumun bütün kesimlerinin kolaylıkla erişimine imkân verecek şekilde elektronik ortamda yayımlanması ve yeni tarihî veriler ışığında sürekli güncellenebilmesini amaçlamaktadır.
          </p>
          <p>
            Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi (CTS) 2024 yılında hayata geçirilmeye başlanmış; 2024 yılından bu yana Cumhurbaşkanlığı Yatırım Programı kapsamında desteklenmektedir. &ldquo;Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi (CTS)&rdquo; kapsamında ilk aşamada, 1923 yılından günümüze kadar uzanan tarihî süreç kademeli ve kapsamlı olarak ele alınacaktır. Türkiye Cumhuriyeti dönemindeki sanat hareketlerinin, sanatçıların, eserlerin yanı sıra koruma, restorasyon, sanat felsefesi, terminoloji üzerine bilgilere de yer vererek öğrenciler, akademisyenler ve sanatseverler başta olmak üzere tüm ilgililerine yönelik eğitim ve farkındalık oluşturmak amaçlanmaktadır.
          </p>
          <p>
            Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi&apos;nin logosu, Cumhuriyetimizin fikrî ve kültürel temellerinin büyük ölçüde atıldığı Ankara Üniversitesi, Dil ve Tarih-Coğrafya Fakültesi (DTCF) binasının mimarisinden esinlenilerek tasarlanmıştır. Bu yönüyle logo, Cumhuriyet dönemi kültürel mirasının sürekliliğini ve akademik temellerini simgelemektedir.
          </p>
          <p>
            Cumhuriyet Dönemi Türk Sanatı Tarihi Ansiklopedisi (CTS), bilimsel etik ve çağdaş dijital yayıncılık ilkeleri doğrultusunda yürütülmektedir. Projede üretilen tüm içerikler; tarafsızlık, doğrulanabilirlik ve akademik güvenilirlik esas alınarak hazırlanmakta, çalışmalar, açık erişimli bir web platformu üzerinden yürütülmekte; veri toplama, arşivleme, sınıflandırma ve dijital sunum süreçleri Bütünleşik Bilgi Sistemi (BBS) aracılığıyla gerçekleştirilmektedir. Farklı uzmanlık alanlarından araştırmacıların katkılarıyla imece usulü bilgi üretimi sağlanmaktadır. Üretilen bilgiler, kolektif zekâ temelli bir işleyiş modeliyle çok aşamalı editoryal denetimden geçirilmektedir. Dijital platform, güncellenebilen dinamik bir yapıya sahiptir. Yeni araştırmalar ve kullanıcı geri bildirimleri doğrultusunda içerikler revize edilebilmektedir.
          </p>
          <p>
            Atatürk Kültür Merkezi Başkanlığı bünyesinde oluşturulan Sanat Tarihi ve Türk Sanatları Bilim ve Uygulama Kolu koordinasyonunda yürütülmekte olan ansiklopedi, madde yazımı, bilimsel değerlendirme ve editoryal denetim aşamalarının ardından kamuoyunun erişimine açılmıştır.
          </p>
          <p>
            Cumhuriyet Dönemi Türk Sanatı Ansiklopedisi, açık erişimli bir web sitesi aracılığıyla, sanat tarihine ilgi duyan herkese kaynak ve bilgi sağlamayı Türkiye Cumhuriyeti dönemi sanatının korunması ve gelecek nesillere aktarılmasını, daha önce az bilinen veya üzerinde yeterince çalışılmamış sanatçıları, akımları veya eserleri keşfetmeyi ve anlamaya da katkı sunmayı ve böylece Türkiye Cumhuriyeti dönemi sanatı hakkında yeni bilgiler ve içgörüler sağlayarak sanat tarihine katkıda bulunmayı hedeflemektedir. Uzun vadede, sanat tarihçileri, akademisyenler, müzeler, sanat galerileri ve diğer kültürel kurumlarla iş birlikleri yapmayı ve ağ oluşturmayı hedeflemektedir.
          </p>
        </section>

        <section className="about-section">
          <h2 className="project-team-title">Proje Ekibi</h2>
          <img
            src="/images/cdtst/dekoratif.png"
            alt="Dekoratif çizgi"
            className="decorative-line"
          />

          <div className="team-grid">
            <div className="team-column">
              <h3>Proje Yürütücüsü</h3>
              <p>Doç. Dr. Zeki ERASLAN</p>
            </div>

            <div className="team-column">
              <h3>Yürütme Kurulu</h3>
              <p>Doç. Dr. Zeki ERASLAN</p>
              <p>Dr. Ömer GÖK</p>
              <p>Evre ÇORUH</p>
              <p>Prof. Dr. Abdülhamit TÜFEKÇİOĞLU</p>
              <p>Dr. Öğr. Üyesi Sema BİLİCİ</p>
            </div>

            <div className="team-column">
              <h3>Editörler</h3>
              <p>Prof. Dr. Abdülhamit TÜFEKÇİOĞLU</p>
              <p>Prof. Dr. Bekir ESKİCİ</p>
              <p>Prof. Dr. Saime DÖNMEZER</p>
              <p>Prof. Dr. Tolga BOZKURT</p>
              <p>Doç. Dr. Emre KOLAY</p>
              <p>Dr. Öğr. Üyesi Sema BİLİCİ</p>
              <p>Dr. Öğr. Üyesi Tuğba GAYRET</p>
              <h3>Dil Editörü</h3>
              <p>Zeynep Akkiraz AYHAN</p>
            </div>

            <div className="team-column">
              <h3>Alan Editör Yardımcıları</h3>
              <p>Doç. Dr. Berna ÇAĞLAR ÖZYURT</p>
              <p>Öğr. Gör. Dr. Mustafa Can KIZGINDEMİR</p>
              <p>Arş. Gör. Dr. Zeynep AYTEKİN</p>
              <p>Arş. Gör. Ahmet Fuat GÖKMEN</p>
              <p>Arş. Gör. Ceren Tuğçe VAROL KOYUNCU</p>
              <p>Arş. Gör. Gökhan MERİÇ</p>
              <p>Arş. Gör. Kubilay ARPACI</p>
              <p>Arş. Gör. Serkan KILIÇ</p>
             
              <p>İlkcan Dilara İNAN</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
